  const object = require('lodash/object');
  const fileTypes = ["css","csv","doc","docx","gif","htm","html","ico","jpg","js","json","log","pdf","png","ppt","pptx","psd","rtf","text","txt","xls","xlsx","xml","zip"]
  const imageTypes = ['jpg','jpeg','gif','png','bmp','svg','ico'];
  const browserTypes = ["css","csv","doc","docx","htm","html","js","json","log","pdf","ppt","pptx","psd","rtf","text","txt","xls","xlsx","xml"]

  const statusDisplay = {
    'a':'Active',
    'c':'Done',
    'u': 'To Do'
  }
  const statusHelp = {
    'a':'Stop work and set as done',
    'c':'Reopen and set state to active',
    'u': 'Start work and set to active'        
  }
  const statusHelpInfo = {
    'a':'Currently in progress',
    'c':'Completed',
    'u': 'Awaiting start'        
  }
  const channelIcons = {
    E: {
      description: 'Email Campaign',
      class:'glyphicons-envelope'
    },
    DM: {
      description: 'Direct Mail',
      class:'glyphicons-newspaper'
    },
    SMS: {
      description: 'SMS Campaign',
      class:'glyphicons-sms'
    },
    DIS: {
      description: 'Display',
      class:'glyphicons-picture'
    },
    SM: {
      description: 'Social Media',
      class: 'glyphicons-thumbs-up'
    }
  }

  fileObj = function(options) {
    this.displayName = (options.displayName!=undefined) ? options.displayName : null;
    this.notes = (options.notes!=undefined) ? options.notes : null;
    this.url = (options.url!=undefined) ? options.url : null;
    this.name = (options.name!=undefined) ? options.name : null;
    this.file_id = (options.file_id!=undefined) ? options.file_id : null;
    this.type = (options.type!=undefined) ? options.type : null;
    this.versions = (options.versions!=undefined) ? options.versions : [];
  }

  isImage = function(type) {
    if ((type) && type.length > 0) {
      if (imageTypes.indexOf(type) != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isBrowserType = function(type) {
    if ((type) && type.length > 0) {
      if (browserTypes.indexOf(type) != -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getFileUrl = function(type) {
    if (fileTypes.indexOf(type)!=-1) {
      return '/images/svg/filetypes-'+ type +'.svg';
    } else {
      return '/images/svg/filetypes-unknown.svg';
    }
  }

  errorException = function(statusCode, customMessage, title, showAlert, alertDuration, callback) {
    this.statusCode = statusCode!=undefined ? statusCode : null;
    this.customMessage = customMessage!=undefined ? customMessage : null;
    this.title = (title) ? title : null; 
    this.showAlert = showAlert!=undefined ? showAlert : false; 
    this.alertDuration = alertDuration!=undefined ? alertDuration : 12000;
    this.callback = callback!=undefined ? callback : null;
  }

  /*
  *Creates a fetch handler, meant to be used as first .then, with sensible defaults.
  */
  fetchHandler = function(msgHandler,options){
    if (!options) options = {};
    options = object.defaults(options,{title:"Error",showAlert:false, verbose:true})
    return function(response){
      if (!response.ok){
        let doErrorHandler = async function(){
          try {
            let result = await response.text()
            let parsedResult = ""
            let title = options.title

            try {
              parsedResult = JSON.parse(result) // will drop down to catch below if not valid JSON
              if (title == 'Error'){
                title += ` - ${result.message}`
              }
            } catch (err) {
              parsedResult = {message: result}
            }
            console.warn(parsedResult)
            response.result = parsedResult
            options.showAlert = true
            return errorHandler(msgHandler,response,title,options)
          } catch(err) {
            console.warn(response)
            let title = "Unexpected Error Encountered"
            options.showAlert = true
            return errorHandler(msgHandler,response,title,options)
          }
        }
        doErrorHandler()
        return response
      }
      return response;
    }
  }

  /*
  * Creates a handler for the "catch" after a fetch.  With sensible defaults.
  * TODO: eventually, this could be built out to hande network errors, and notify the user they are offline
  * or something like that.
  */
  fetchCatcher = function(msgHandler,options){
    if (!options) options = {};
    options = object.defaults(options,{
      title:"Fetch error",
      showAlert:false,    
      verbose:false
    })
    return function(e){
      options.exception = e;
      errorHandler(msgHandler,(options.msg)?options.msg:e,options.title,options);
    }
  }


  errorHandler = function(msgHandler, response, title, options){
    let dispatch = null;
    if (msgHandler.$root){
      //msgHandler is a vue app. 
      //use $emit function as msg handler.  For whatever reason, it doesn't
      //work assigning $emit directly to dispatch. wrapping it in a function works.  
      dispatch = function(type,opts){
        msgHandler.$eventBus.$emit(type,opts)
      } 
    } else {
      dispatch = msgHandler;
    }
    let showAlert = (options!=undefined) ? options.showAlert : false;
    let exceptions = (options!=undefined && options.exceptions) ? options.exceptions : [];
    let ajaxObject = (options!=undefined && options.ajaxObject) ? options.ajaxObject : null;
    let verbose = (options!=undefined && options.verbose) ? options.verbose : false;
    let noRedirect = (options!=undefined && options.noRedirect) ? true : false;

    if (title==undefined || title==null) title = "Error";
    
    /*
    if (response.result && response.result.message) {
      title += ` - ${response.result.message}`
    }
    */

    const ERR_GENERIC = "generic";
    const ERR_FETCH = "fetch";
    const ERR_AJAX = "ajax";
    const ERR_FETCH_FAILED = "fetch_failed";
    let errType = ERR_GENERIC;
    if (response.responseJSON) {
      errType = ERR_AJAX;
    } else if (response.status) {
      errType = ERR_FETCH;
    } else if (response.toString().substring(0,9).toLowerCase()=='typeerror') {
      // check response string below for browser specific values
      /* 
        Chrome - TypeError: Failed to fetch
        Firefox - TypeError: NetworkError when attempting to fetch resource.
        Safari - TypeError: Type error
      */
      if (response.toString().toLowerCase().indexOf('fetch') != -1 || response.toString().toLowerCase() == 'typeerror: type error') {
        errType = ERR_FETCH_FAILED;
      }
    }

    let errMsg = ``;
    let alertDuration = 15000;
    let specialHandling = [];

    // see if we've passed in special handling for any specific status codes
    if (exceptions.length && errType!=ERR_GENERIC) {
      specialHandling = exceptions.filter((itm)=>{
        return itm.statusCode == ((errType==ERR_FETCH) ? response.status : response.responseJSON.statusCode);
      });
      if (specialHandling.length) {
        showAlert = specialHandling[0].showAlert;
        alertDuration = specialHandling[0].alertDuration;
        if (specialHandling[0].title) title = specialHandling[0].title;
      }  
    }
    console.log("errorHandler")
    if ((errType!=ERR_GENERIC && errType!=ERR_FETCH_FAILED) && !noRedirect) { // check to see if session is still active, and redirect to login page if not
      if (401 == ((errType==ERR_FETCH) ? response.status : response.responseJSON.statusCode)) {
        console.log("401")
        showAlert = false;
        dispatch('showMessage',{
          msg:'Your session is no longer active, and you have been logged out. Click OK to be redirected to the login page.',
          isStatic: true,
          title:'Session Expired',
          btnText:'OK',
          callback: ()=>{window.location.href = '/login'}
        });
      }
    }

    if (showAlert) {
      var alertMsg = '';
      if (specialHandling.length && specialHandling[0].customMessage) {
        alertMsg += `<span>${specialHandling[0].customMessage}</span>`;
      } else if (errType==ERR_FETCH) {
        alertMsg += `${response.status}: ${response.statusText}`;

        if (response.result && response.result.message) {
          alertMsg += `<br><br><b>Error Details</b><br>${response.result.message}<br>`
        }
        if (verbose) {
          alertMsg += '<span class="small">';
          if (response.url) alertMsg += `<br>URL: <i>${response.url}</i>`;
          alertMsg += '</span>';
        }
      } else if (errType==ERR_AJAX) {
        alertMsg += `${response.responseJSON.statusCode}: ${response.responseJSON.error}`;
        if (response.responseJSON.message) alertMsg += `<br><br>${response.responseJSON.message}`;
        if (verbose) { 
          alertMsg += '<span class="small">';
          if (ajaxObject) alertMsg += `<br><br><b>method:</b> ${ajaxObject.type}<br><b>URL:</b> <i>${ajaxObject.url}</i>`;
          alertMsg += '</span>';  
        }
      } else if (errType==ERR_FETCH_FAILED) {
        alertMsg = 'Unable to reach server';
        if (title.toLowerCase()=='error' || title.toLowerCase()=='fetch error') {
          title = 'Network Error';
        }
      } else {
        alertMsg += response;
        if (verbose && options.exception){
          alertMsg += `<span class="small">${options.exception}</span>`;
        }
      }
      dispatch('showStatus',{msg:alertMsg,title:title,isWarning:true,duration:alertDuration});
    }

    // TODO: ERR_FETCH check is broken - need to refactor how objects are passed into housekeeping functions
    if (errType==ERR_FETCH) {
      errMsg += `%c${response.status}: ${response.statusText}%c`;
      if (response.result && response.result.message) {
        errMsg += `\n${response.result.message}`
      }
      if (response.url) errMsg += `\n${response.url}`;
      errMsg = `${title}\n${errMsg}`; 
      console.warn(errMsg, "color: #7d5b21; font-weight: 600;","font-style: italic");
    } else if (errType==ERR_AJAX) {
      console.log(response);
      errMsg += `%c${response.responseJSON.statusCode}: ${response.responseJSON.error}%c`;
      if (response.responseJSON.message) errMsg += `\n${response.responseJSON.message}`;
      if (ajaxObject) errMsg += `\n\nmethod: ${ajaxObject.type}\nURL: ${ajaxObject.url}`;
      console.warn(`${title}\n${errMsg}`, "color: #7d5b21; font-weight: 600;","font-style: italic");
    } else if (errType==ERR_FETCH_FAILED) {
      errMsg = 'Unable to reach server during fetch';
      console.warn(`%c${title}%c\n${errMsg}`, "color: #7d5b21; font-weight: 600;","font-style: italic");
    } else {
      errMsg += response;
      console.warn(`${title}\n${errMsg}`);
      if (options.exception){
        console.log(options.exception);
      }
    }

  }

  getLocalStorage = function(key,defaultValue=null,isBoolean=false,constrainValues=[]) {
    let ret = localStorage.getItem(key);

    if (ret!=undefined && ret!=null) {
      if (isBoolean && ret=="true") {
        ret = true;
      } else if (isBoolean && ret=="false") {
        ret = false;
      } else if (constrainValues.length) {
        if (constrainValues.indexOf(ret)==-1) {
          ret = (defaultValue) ? defaultValue : null;
        }
      }
    } else if (defaultValue!=null){
      ret = defaultValue;
    }
    return ret;
  }
  
  module.exports = {fetchCatcher,fetchHandler,errorHandler,errorException, fileObj, isImage, getFileUrl, fileTypes, isBrowserType, statusDisplay, statusHelp, statusHelpInfo, channelIcons, getLocalStorage};